import axios from "axios";
import axiosRetry from 'axios-retry';
import * as FormData from "form-data";
import { pServer } from "../../utils/parameters";
import {getReportDevice} from '../../api/utils/device';

apiRest_getDataVersusMachine, apiRest_sendDatasetBuilder

const apiRest_basic_config = {
  apiRest_pingServer: { 'endpoint':'/ping','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_pingServer },
  apiRest_getJSONData: { 'endpoint':'/JSONData','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getJSONData },
  apiRest_getVideoData: { 'endpoint':'/VideoData','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getVideoData },
  apiRest_getJSONWebInfo: { 'endpoint':'/webInfo','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getJSONWebInfo },
  apiRest_sendCollaboration: { 'endpoint':'/collaboration','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_sendCollaboration },
  apiRest_updateFeedback: { 'endpoint':'/feedback','method': "PUT", 'timeout': pServer.timeout, 'function': apiRest_updateFeedback },
  apiRest_sendVideo: { 'endpoint':'/sendVideo','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_sendVideo },
  apiRest_sendMediapipe: { 'endpoint':'/sendMediapipe','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_sendMediapipe },
  apiRest_sendMediapipeFastMode: { 'endpoint':'/sendMediapipeFastMode','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_sendMediapipeFastMode },
  apiRest_sendVideoFS: { 'endpoint':'/sendVideoFS','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_sendVideoFS },
  

  apiRest_getDatasetBuilder: { 'endpoint':'/datasetBuilder','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getDatasetBuilder },
  apiRest_getVideoDatasetBuilder: { 'endpoint':'/datasetBuilderVideo','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getVideoDatasetBuilder },
  apiRest_sendDatasetBuilder: { 'endpoint':'/datasetBuilder','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_sendDatasetBuilder },

  apiRest_getDatasetBuilderSentence: { 'endpoint':'/datasetBuilderSentence','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getDatasetBuilderSentence },
  apiRest_sendDatasetBuilderSentence: { 'endpoint':'/datasetBuilderSentence','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_sendDatasetBuilderSentence },
  apiRest_deleteDatasetBuilderSentence: { 'endpoint':'/datasetBuilderSentence','method': "DELETE", 'timeout': pServer.timeout, 'function': apiRest_deleteDatasetBuilderSentence },

  apiRest_getDonateSign: { 'endpoint':'/donateSign','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getDonateSign },
  apiRest_sendDonateSign: { 'endpoint':'/donateSign','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_sendDonateSign },

  apiRest_getDataVersusMachine: { 'endpoint':'/versusMachine','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getDataVersusMachine },
  apiRest_sendDataVersusMachine: { 'endpoint':'/versusMachine','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_sendDataVersusMachine },
  apiRest_getDataVersusMachine2: { 'endpoint':'/versusMachine2','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getDataVersusMachine2 },
  apiRest_sendDataVersusMachine2: { 'endpoint':'/versusMachine2','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_sendDataVersusMachine2 },

  apiRest_getDataMoveYourSkeleton: { 'endpoint':'/moveYourSkeleton','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getDataMoveYourSkeleton },
  apiRest_sendResultsMoveYourSkeleton: { 'endpoint':'/moveYourSkeleton','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_sendResultsMoveYourSkeleton },
  apiRest_sendVideoMoveYourSkeleton: { 'endpoint':'/moveYourSkeletonVideo','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_sendVideoMoveYourSkeleton },


  apiRest_createReportBug: { 'endpoint':'/reportBug','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_createReportBug },
  apiRest_getReportBug: { 'endpoint':'/reportBug','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getReportBug },
  apiRest_updateReportBug: { 'endpoint':'/reportBug','method': "PUT", 'timeout': pServer.timeout, 'function': apiRest_updateReportBug },
  apiRest_closeReportBug: { 'endpoint':'/reportBug','method': "DELETE", 'timeout': pServer.timeout, 'function': apiRest_closeReportBug },
  apiRest_getJSONDataUser: { 'endpoint':'/userData','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getJSONDataUser },
  // apiRest_create_User: { 'endpoint':'/userData','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_create_User },
  apiRest_updateProfile: { 'endpoint':'/profile','method': "PUT", 'timeout': pServer.timeout, 'function': apiRest_updateProfile },
  apiRest_updateTheme: { 'endpoint':'/theme','method': "PUT", 'timeout': pServer.timeout, 'function': apiRest_updateTheme },
  apiRest_updateLang: { 'endpoint':'/language','method': "PUT", 'timeout': pServer.timeout, 'function': apiRest_updateLang },

  apiRest_updateSession: { 'endpoint':'/session','method': "PUT", 'timeout': pServer.timeout, 'function': apiRest_updateSession },


  apiRest_addFavorites: { 'endpoint':'/favorites','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_addFavorites },
  apiRest_removeFavorites: { 'endpoint':'/favorites','method': "DELETE", 'timeout': pServer.timeout, 'function': apiRest_removeFavorites },
  apiRest_getHistory: { 'endpoint':'/history','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getHistory },
  apiRest_addHistory: { 'endpoint':'/history','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_addHistory },
  apiRest_removeHistory: { 'endpoint':'/history','method': "DELETE", 'timeout': pServer.timeout, 'function': apiRest_removeHistory },
  apiRest_getRecords: { 'endpoint':'/records','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getRecords },
  // apiRest_addRecord: { 'endpoint':'/records','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_addRecord },
  apiRest_updateRecord: { 'endpoint':'/records','method': "PUT", 'timeout': pServer.timeout, 'function': apiRest_updateRecord },
  apiRest_removeRecord: { 'endpoint':'/records','method': "DELETE", 'timeout': pServer.timeout, 'function': apiRest_removeRecord },
  apiRest_revertRemoveRecord: { 'endpoint':'/records','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_revertRemoveRecord },
  apiRest_updateDefaultPermission: { 'endpoint':'/defaultPermission','method': "PUT", 'timeout': pServer.timeout, 'function': apiRest_updateDefaultPermission },
  apiRest_updateEmailPermission: { 'endpoint':'/emailPermission','method': "PUT", 'timeout': pServer.timeout, 'function': apiRest_updateEmailPermission },
  apiRest_updateDefaultCamera: { 'endpoint':'/defaultCamera','method': "PUT", 'timeout': pServer.timeout, 'function': apiRest_updateDefaultCamera },
  apiRest_getMessage: { 'endpoint':'/message','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getMessage },
  apiRest_createMessage: { 'endpoint':'/message','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_createMessage },
  apiRest_removeMessage: { 'endpoint':'/message','method': "DELETE", 'timeout': pServer.timeout, 'function': apiRest_removeMessage },


  apiRest_getReportUserActivity : { 'endpoint':'/reportUserActivity','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getReportUserActivity },
  apiRest_getReportTeamActivity : { 'endpoint':'/reportUserActivity','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getReportTeamActivity },
  apiRest_getReportActivity : { 'endpoint':'/reportActivity','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getReportActivity },
  
  apiRest_createTeam : { 'endpoint':'/team','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_createTeam },
  apiRest_getInfoTeam : { 'endpoint':'/team','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getInfoTeam },
  apiRest_removeTeam : { 'endpoint':'/team','method': "DELETE", 'timeout': pServer.timeout, 'function': apiRest_removeTeam },
  apiRest_updateTeam : { 'endpoint':'/team','method': "PUT", 'timeout': pServer.timeout, 'function': apiRest_updateTeam },

  
  apiRest_requestInvitationMemberTeam : { 'endpoint':'/memberTeam','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_requestInvitationMemberTeam },
  apiRest_acceptInvitationMemberTeam : { 'endpoint':'/memberTeam','method': "PUT", 'timeout': pServer.timeout, 'function': apiRest_acceptInvitationMemberTeam },
  apiRest_getInfoMemberTeam : { 'endpoint':'/memberTeam','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getInfoMemberTeam },
  apiRest_cancelInvitationMemberTeam : { 'endpoint':'/memberTeam','method': "DELETE", 'timeout': pServer.timeout, 'function': apiRest_cancelInvitationMemberTeam },


  apiRest_getRankDataTeam : { 'endpoint':'/rankTeam','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getRankDataTeam },

  apiRest_createTaskTeam : { 'endpoint':'/taskTeam','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_createTaskTeam },
  apiRest_getTaskTeam : { 'endpoint':'/taskTeam','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getTaskTeam },
  apiRest_removeTaskTeam : { 'endpoint':'/taskTeam','method': "DELETE", 'timeout': pServer.timeout, 'function': apiRest_removeTaskTeam },
  apiRest_updateTaskTeam : { 'endpoint':'/taskTeam','method': "PUT", 'timeout': pServer.timeout, 'function': apiRest_updateTaskTeam },


  apiRest_sendSubmission: { 'endpoint':'/submission','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_sendSubmission },

  apiRest_getLeaderboard: { 'endpoint':'/leaderboard','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getLeaderboard },

  apiRest_donateResponse: { 'endpoint':'/donateResponse','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_donateResponse },
  apiRest_getDonateResponse: { 'endpoint':'/donateResponse','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getDonateResponse },
  apiRest_donateSentence: { 'endpoint':'/donateSentence','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_donateSentence },
  apiRest_getDonateSentence: { 'endpoint':'/donateSentence','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getDonateSentence },

  apiRest_getDonateFingerspelling: { 'endpoint':'/donateFS','method': "GET", 'timeout': pServer.timeout, 'function': apiRest_getDonateFingerspelling },
  apiRest_sendDonateFingerspelling: { 'endpoint':'/donateFS','method': "POST", 'timeout': pServer.timeout, 'function': apiRest_sendDonateFingerspelling },


  apiRest_sendResponseSurvey : { 'endpoint':'/survey','method': "PUT", 'timeout': pServer.timeout, 'function': apiRest_sendResponseSurvey },

}


// Configurar axios para reintentar solicitudes
axiosRetry(axios, {
  retries: 5, // Número de reintentos
  retryDelay: (retryCount) => {
    return retryCount * 1000; // Factor de retroceso (1 segundo por intento)
  },
  retryCondition: (error) => {
    // Condiciones para reintentar (códigos de estado HTTP)
    // return error.response && [408, 429, 500, 502, 503, 504].includes(error.response.status);
    return axiosRetry.isNetworkOrIdempotentRequestError(error) || (error.response && (error.response.status < 200 || error.response.status >= 300));
  },
  onRetry: (retryCount, error, requestConfig) => {
    console.log(`Intento número ${retryCount} para la solicitud:`, requestConfig.url);
  }
});


// Send ping to server to check if it is alive
export async function apiRest_pingServer(server_addr) {    // GET
  const config_key = 'apiRest_pingServer'
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    headers: {},
  };

  return axios(config).then(response => response.data)
}

export async function apiRest_getJSONData(data_json, server_addr) {    // GET
  const config_key = 'apiRest_getJSONData'
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    params: {
      'data_json': data_json,
      'prev_timestamp': Date.now(),
    }
  };
  return axios(config).then(response => response.data)
}

export async function apiRest_getVideoData(token_id, user_id, video_origin, video_filename, type, server_addr) {    // GET

  const config_key = 'apiRest_getVideoData'
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    responseType: "blob",
    auth: {
      username: user_id,
      password: token_id
    },
    params: {
      'video_origin': video_origin,
      'video_filename': video_filename,
      'type': type
    }
  };
  // console.log('CONFIG apiRest_getVideoData', config)
  return axios(config).then(response => (window.URL || window.webkitURL).createObjectURL(new Blob([response.data], { type: "video/mp4" })))

}



export async function apiRest_getJSONWebInfo(server_addr) {    // GET
  const config_key = 'apiRest_getJSONWebInfo'
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    params: {
      prev_timestamp: Date.now(),
    }
  };
  return axios(config).then(response => response.data)
}

export async function apiRest_sendCollaboration(token_id, user_id, data, data_labels, f, team_id, task_id, server_addr) {  // POST
  const config_key = 'apiRest_sendCollaboration'

  var formData = new FormData();
  formData.append(pServer.form_feedback_lemma+'_id', data.lemma);
  formData.append(pServer.form_feedback_meaning+'_id', data.meaning);
  formData.append(pServer.form_feedback_gloss+'_id', data.gloss);

  formData.append(pServer.form_feedback_lemma+'_label', data_labels.lemma);
  formData.append(pServer.form_feedback_meaning+'_label', data_labels.meaning);
  formData.append(pServer.form_feedback_gloss+'_label', data_labels.gloss);

  formData.append('team_id', team_id);
  formData.append('task_id', task_id);

  formData.append(pServer.form_video, f);

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: formData
  };
  return axios(config).then(response => response.data)
}

export async function apiRest_getDonateFingerspelling(token_id, user_id, server_addr) {  // POST
  const config_key = 'apiRest_getDonateFingerspelling'
  var formData = new FormData();

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: formData
  };
  return axios(config).then(response => response.data)
}


export async function apiRest_sendDonateFingerspelling(token_id, user_id, feedback_lemma_fs_label, f, team_id, task_id, server_addr) {  // POST
  const config_key = 'apiRest_sendDonateFingerspelling'

  var formData = new FormData();
  formData.append('feedback_lemma_fs_label', feedback_lemma_fs_label);
  formData.append('team_id', team_id);
  formData.append('task_id', task_id);

  formData.append(pServer.form_video, f);

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: formData
  };
  return axios(config).then(response => response.data)
}



export async function apiRest_donateSentence(token_id, user_id, f, data, server_addr) {  // POST
  const config_key = 'apiRest_donateSentence'

  var formData = new FormData();
  formData.append('sentence_id', data.sentence_id);
  formData.append('sentence_label', data.sentence_label);
  formData.append('text_activated', data.text_activated)
  formData.append('isValid', data.isValid);
  formData.append('notEqualCases', JSON.stringify(data.notEqualCases));
  formData.append('userReport', JSON.stringify(await getReportDevice()))
  formData.append(pServer.form_video, f);


  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: formData
  };

  return axios(config).then(response => response.data)
}


export async function apiRest_getDonateSentence(token_id, user_id, server_addr) {  // POST
  const config_key = 'apiRest_getDonateSentence'
  var formData = new FormData();

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: formData
  };
  return axios(config).then(response => response.data)
}



export async function apiRest_donateResponse(token_id, user_id, f, data, server_addr) {  // POST
  console.log("🚀 ~ apiRest_donateResponse ~ apiRest_donateResponse:", apiRest_donateResponse)
  const config_key = 'apiRest_donateResponse'

  var formData = new FormData();
  formData.append('sentence_id', data.sentence_id);
  formData.append('sentence_label', data.sentence_label);
  formData.append('isValid', data.isValid);
  formData.append('userReport', JSON.stringify(getReportDevice()))

  formData.append(pServer.form_video, f);

  

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: formData
  };
  return axios(config).then(response => response.data)
}

export async function apiRest_getDonateResponse(token_id, user_id, server_addr) {  // POST
  const config_key = 'apiRest_getDonateResponse'
  var formData = new FormData();

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: formData
  };
  return axios(config).then(response => response.data)
}








export async function apiRest_updateFeedback(token_id, user_id, video_id, data, data_labels, server_addr) {  // PUT

  const config_key = 'apiRest_updateFeedback'


  // console.log('UPDATEFEEDBACK - token_id', token_id)
  // console.log('UPDATEFEEDBACK - user_id', user_id)
  // console.log('UPDATEFEEDBACK - video_id', video_id)
  // console.log('UPDATEFEEDBACK - data', data)
  // console.log('UPDATEFEEDBACK - data_labels', data_labels)



  const feedback = {
    'video_id': video_id,
    'feedback_id': data,
    'feedback_label': data_labels,
  }
  
  const config = {
    method: apiRest_basic_config[config_key]['method'],  // PUT
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: feedback
  };  

  // console.log('UPDATEFEEDBACK - config', config)

  return axios(config).then(response => response.data)
}

export async function apiRest_sendVideo(token_id, user_id, f, server_addr) {  // POST
  const config_key = 'apiRest_sendVideo'

  var formData = new FormData();
  formData.append(pServer.form_video, f);
  // formData.append(pServer.form_video, f, 'nombre.mp4');

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data : formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  };
  return axios(config).then(response => response.data)
}

export async function apiRest_sendMediapipe(token_id, user_id, video, mediapipe, server_addr) {   // POST
  const config_key = 'apiRest_sendMediapipe'

  var formData = new FormData();
  formData.append('file', video);
  formData.append('mediapipe', mediapipe);

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data : formData
  };
  return axios(config).then(response => response.data)
}

export async function apiRest_sendMediapipeFastMode(token_id, user_id, mediapipe, server_addr) {   // POST
  const config_key = 'apiRest_sendMediapipeFastMode'

  var formData = new FormData();
  formData.append('mediapipe', mediapipe);

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data : formData
  };
  return axios(config).then(response => response.data)
}


export async function apiRest_sendVideoFS(token_id, user_id, f, server_addr) {  // POST
  const config_key = 'apiRest_sendVideoFS'

  var formData = new FormData();
  formData.append(pServer.form_video, f);
  // formData.append(pServer.form_video, f, 'nombre.mp4');

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data : formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  };
  return axios(config).then(response => response.data)
}





export async function apiRest_getDatasetBuilder(token_id, user_id, session, edit_annotation_idx, server_addr) {    // GET
  // var data = new FormData();
  const config_key = 'apiRest_getDatasetBuilder'
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    params: {
      'session': session,
      'edit_annotation_idx': edit_annotation_idx,
    }
  };

  console.log('CONFIG apiRest_getVideoDatasetBuilder', config)
  return axios(config).then(response => response.data)
}

export async function apiRest_getVideoDatasetBuilder(token_id, user_id, session, filename, server_addr) {    // GET
  // var data = new FormData();
  const config_key = 'apiRest_getVideoDatasetBuilder'
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    responseType: "blob",
    auth: {
      username: user_id,
      password: token_id
    },
    params: {
      'session': session,
      'filename': filename,
    }
  };

  console.log('CONFIG apiRest_getVideoDatasetBuilder', config)

  return axios(config).then(response => (window.URL || window.webkitURL).createObjectURL(new Blob([response.data], { type: "video/mp4" })))
}

export async function apiRest_sendDatasetBuilder(token_id, user_id, session, filename, class_id, annotation_code_id, comment, counter_repeats_used, history_log, edit_annotation_idx, server_addr = pServer.server_url) {  // POST

  const config_key = 'apiRest_sendDatasetBuilder'

  var formData = new FormData();
  formData.append(pServer.form_session, session);
  formData.append(pServer.form_filename, filename);
  formData.append(pServer.form_class_id, class_id);
  formData.append(pServer.form_annotation_code_id, annotation_code_id);
  formData.append(pServer.form_comment, comment);
  formData.append(pServer.form_counter_repeats_used, counter_repeats_used);
  formData.append(pServer.form_history_log, history_log);
  formData.append("edit_annotation_idx", edit_annotation_idx);


  console.log('CONFIG formData - session', session)
  console.log('CONFIG formData - filename', filename)
  console.log('CONFIG formData - class_id', class_id)
  console.log('CONFIG formData - annotation_code_id', annotation_code_id)
  console.log('CONFIG formData - comment', comment)
  console.log('CONFIG formData - counter_repeats_used', counter_repeats_used)
  console.log('CONFIG formData - history_log', history_log)
  console.log('CONFIG formData - edit_annotation_idx', edit_annotation_idx)
  
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data : formData
  };

  console.log('CONFIG apiRest_sendDatasetBuilder', config)
  console.log('CONFIG apiRest_sendDatasetBuilder', formData)

  return axios(config).then(response => response.data)
}



export async function apiRest_getDatasetBuilderSentence(token_id, user_id, scope, origin, record_id, filter_by_previous, server_addr) {    // GET
  // var data = new FormData();
  const config_key = 'apiRest_getDatasetBuilderSentence'
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    params: {
      'origin': origin,
      'record_id': record_id,
      'filter_by_previous': filter_by_previous,
      'scope': scope
    }
  };

  console.log('CONFIG apiRest_getVideoDatasetBuilder', config)
  return axios(config).then(response => response.data)
}


export async function apiRest_sendDatasetBuilderSentence(token_id, user_id, data_annotation, server_addr = pServer.server_url) {  // POST

  const config_key = 'apiRest_sendDatasetBuilderSentence'

  var formData = new FormData();
  formData.append("record_id", data_annotation["record_id"]);

  formData.append("origin", data_annotation["origin"]);

  formData.append("annotation_status", data_annotation["annotation_status"]);
  formData.append("annotation_isEqualCases", data_annotation["annotation_isEqualCases"]);
  formData.append("annotation_notEqualCases_diffSigns", data_annotation["annotation_notEqualCases_diffSigns"]);
  formData.append("annotation_notEqualCases_diffOrder", data_annotation["annotation_notEqualCases_diffOrder"]);
  formData.append("annotation_notEqualCases_diffNumberSigns", data_annotation["annotation_notEqualCases_diffNumberSigns"]);

  formData.append("annotation_arr_options_labels", data_annotation["annotation_arr_options_labels"]);
  formData.append("annotation_arr_options_idx", data_annotation["annotation_arr_options_idx"]);
  formData.append("annotation_comment", data_annotation["annotation_comment"]);
  formData.append("annotation_timestamp", data_annotation["annotation_timestamp"]);

  formData.append("annotation_proposed_text", data_annotation["annotation_proposed_text"]);

  console.log('CONFIG formData - annotation_status', data_annotation["annotation_status"])
  console.log('CONFIG formData - annotation_timestamp', data_annotation["annotation_timestamp"])
  console.log('CONFIG formData - annotation_isEqualCases', data_annotation["annotation_isEqualCases"])
  console.log('CONFIG formData - annotation_notEqualCases_diffSigns', data_annotation["annotation_notEqualCases_diffSigns"])
  console.log('CONFIG formData - annotation_notEqualCases_diffOrder', data_annotation["annotation_notEqualCases_diffOrder"])
  console.log('CONFIG formData - annotation_notEqualCases_diffNumberSigns', data_annotation["annotation_notEqualCases_diffNumberSigns"])
  console.log('CONFIG formData - annotation_arr_options_labels', data_annotation["annotation_arr_options_labels"])
  console.log('CONFIG formData - annotation_arr_options_idx', data_annotation["annotation_arr_options_idx"])
  console.log('CONFIG formData - annotation_comment', data_annotation["annotation_comment"])
  
  
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data : formData
  };

  console.log('CONFIG apiRest_sendDatasetBuilder', config)
  console.log('CONFIG apiRest_sendDatasetBuilder', formData)

  return axios(config).then(response => response.data)
}


export async function apiRest_deleteDatasetBuilderSentence(token_id, user_id, origin, record_id, annotation_timestamp, server_addr) {  // DEL

  const config_key = 'apiRest_deleteDatasetBuilderSentence'

  var formData = new FormData();
  formData.append(pServer.form_record_id, record_id);
  formData.append(pServer.form_origin, origin);
  formData.append(pServer.annotation_timestamp, annotation_timestamp);  

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: formData
  };
  return axios(config).then(response => response.data)
}



















export async function apiRest_getDonateSign(token_id, user_id, server_addr) {  // GET
  const config_key = 'apiRest_getDonateSign'
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
  };

  return axios(config).then(response => response.data)
}

export async function apiRest_sendDonateSign(token_id, user_id, data, data_labels, f, server_addr) {  // POST
  const config_key = 'apiRest_sendDonateSign'

  var formData = new FormData();
  formData.append(pServer.form_feedback_lemma+'_id', data.lemma);
  formData.append(pServer.form_feedback_meaning+'_id', data.meaning);
  formData.append(pServer.form_feedback_gloss+'_id', data.gloss);

  formData.append(pServer.form_feedback_lemma+'_label', data_labels.lemma);
  formData.append(pServer.form_feedback_meaning+'_label', data_labels.meaning);
  formData.append(pServer.form_feedback_gloss+'_label', data_labels.gloss);

  formData.append(pServer.form_video, f);

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: formData
  };

  return axios(config).then(response => response.data)
}


export async function apiRest_getDataVersusMachine(token_id, user_id, server_addr) {  // GET
  const config_key = 'apiRest_getDataVersusMachine'

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
  };

  return axios(config).then(response => response.data)
}

export async function apiRest_sendDataVersusMachine(token_id, user_id, elements_response_send, server_addr) {  // POST
  const config_key = 'apiRest_sendDataVersusMachine'

  const elements_response_send_copy = { ...elements_response_send }
  delete elements_response_send_copy['speed']
  delete elements_response_send_copy['arr_lemmas_options']

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: elements_response_send_copy
  };

  // console.log('apiRest_sendDataVersusMachine - config', config)

  return axios(config).then(response => response.data)
}

export async function apiRest_getDataVersusMachine2(token_id, user_id, server_addr) {  // GET
  const config_key = 'apiRest_getDataVersusMachine2'

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
  };

  return axios(config).then(response => response.data)
}

export async function apiRest_sendDataVersusMachine2(token_id, user_id, elements_response_send, server_addr) {  // POST
  const config_key = 'apiRest_sendDataVersusMachine2'

  const elements_response_send_copy = { ...elements_response_send }
  delete elements_response_send_copy['speed']
  delete elements_response_send_copy['arr_lemmas_options']

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: elements_response_send_copy
  };

  // console.log('apiRest_sendDataVersusMachine - config', config)

  return axios(config).then(response => response.data)
}



export async function apiRest_getDataMoveYourSkeleton(token_id, user_id, server_addr) {  // GET
  const config_key = 'apiRest_getDataMoveYourSkeleton'

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
  };

  return axios(config).then(response => response.data)
}

export async function apiRest_sendResultsMoveYourSkeleton(token_id, user_id, elements_response_send, server_addr) {  // POST
  
  const config_key = 'apiRest_sendResultsMoveYourSkeleton'

  // console.log("🚀 ~ file: RESTful.js:418 ~ apiRest_sendResultsMoveYourSkeleton ~ elements_response_send:", elements_response_send)

  // var formData = new FormData();
  // formData.append('gloss_id', elements_response_send.gloss_id);
  // formData.append('video_user', elements_response_send.video_user);
  // formData.append('counter_repeats_used', elements_response_send.counter_repeats_used);
  // formData.append('score_kps', elements_response_send.score_kps);

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: elements_response_send
  };
  // console.log('apiRest_sendDataVersusMachine - config', config)
  return axios(config).then(response => response.data)
}


export async function apiRest_sendVideoMoveYourSkeleton(token_id, user_id, data, data_labels, f, server_addr) {  // POST
  const config_key = 'apiRest_sendVideoMoveYourSkeleton'

  var formData = new FormData();
  formData.append(pServer.form_feedback_lemma+'_id', data.lemma);
  formData.append(pServer.form_feedback_meaning+'_id', data.meaning);
  formData.append(pServer.form_feedback_gloss+'_id', data.gloss);

  formData.append(pServer.form_feedback_lemma+'_label', data_labels.lemma);
  formData.append(pServer.form_feedback_meaning+'_label', data_labels.meaning);
  formData.append(pServer.form_feedback_gloss+'_label', data_labels.gloss);

  formData.append(pServer.form_video, f);

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data : formData
  };
  return axios(config).then(response => response.data)
}


export async function apiRest_createReportBug(token_id, user_id, data, server_addr) {  // POST
  const config_key = 'apiRest_createReportBug'

  var formData = new FormData();
  formData.append(pServer.form_titleBug, data['title']);
  formData.append(pServer.form_bodyBug, data['body']);
  formData.append(pServer.form_labelsBug, data['labels']);

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: formData
  };
  return axios(config).then(response => response.data)
}

export async function apiRest_getReportBug(token_id, user_id, owner_id, query, server_addr) {    // GET
  const config_key = 'apiRest_getReportBug'
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    params: {
      'owner_id': owner_id,
      'query': query
    }
  };
  return axios(config).then(response => response.data)
}

export async function apiRest_updateReportBug(token_id, user_id, server_addr) {  // PUT
  // config_key = 'apiRest_updateReportBug'
  // const config = {
  //   method: apiRest_basic_config[config_key]['method'],
  //   url: server_addr + apiRest_basic_config[config_key]['endpoint'],
  //   timeout: apiRest_basic_config[config_key]['timeout'],
  //   auth: {
  //     username: user_id,
  //     password: token_id
  //   },
  // };

  // return axios(config).then(response => response.data)
  throw Error('[apiRest_updateReportBug] Not implemented yet')
}

export async function apiRest_closeReportBug(token_id, user_id, server_addr) {  // DEL
  // config_key = 'apiRest_closeReportBug'
  // const config = {
  //   method: apiRest_basic_config[config_key]['method'],
  //   url: server_addr + apiRest_basic_config[config_key]['endpoint'],
  //   timeout: apiRest_basic_config[config_key]['timeout'],
  //   auth: {
  //     username: user_id,
  //     password: token_id
  //   },
  // };

  // return axios(config).then(response => response.data)
  throw Error('[apiRest_closeReportBug] Not implemented yet')
}

export async function apiRest_getJSONDataUser(token_id, user_id, server_addr) {   // GET

  const config_key = 'apiRest_getJSONDataUser'
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    }
  };
  return axios(config).then(response => response.data)
}

export async function apiRest_updateProfile(token_id, user_id, changedFields, server_addr) {  // PUT
  const config_key = 'apiRest_updateProfile'
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data : changedFields
  };
  return axios(config).then(response => response.data)
}

export async function apiRest_updateTheme(token_id, user_id, theme, server_addr) {  // PUT
  const config_key = 'apiRest_updateTheme'
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data : {'theme': theme}
  };
  return axios(config).then(response => response.data)
}

export async function apiRest_updateLang(token_id, user_id, lang, server_addr) {  // PUT
  const config_key = 'apiRest_updateLang'
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data : {'lang': lang}
  };
  return axios(config).then(response => response.data)
}


export async function apiRest_updateSession(token_id, user_id, updated_data, server_addr) {  // PUT

  // console.log('apiRest_updateSession')
  // console.log('user_id' , user_id)
  // console.log('token_id' , user_id)
  // console.log('updated_data' , updated_data)

  const config_key = 'apiRest_updateSession'
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data : updated_data
  };
  return axios(config).then(response => response.data)
}

export async function apiRest_addFavorites(token_id, user_id, elementToAdd, server_addr) {  // POST
  const config_key = 'apiRest_addFavorites'

  var formData = new FormData();
  formData.append('fav', elementToAdd);

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: formData
  };
  return axios(config).then(response => response.data)
}

export async function apiRest_removeFavorites(token_id, user_id, elementToRemove, server_addr) {  // DEL
  const config_key = 'apiRest_removeFavorites'

  var formData = new FormData();
  formData.append('fav', elementToRemove);

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: formData
  };
  return axios(config).then(response => response.data)
}


export async function apiRest_getHistory(token_id, user_id, server_addr) {  // POST
  const config_key = 'apiRest_getHistory'
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    }
  };
  return axios(config).then(response => response.data)
}


export async function apiRest_addHistory(token_id, user_id, lemma_id, date, server_addr) {  // POST
  const config_key = 'apiRest_addHistory'

  var formData = new FormData();
  formData.append('lemma', lemma_id);
  formData.append('date', date);

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: formData
  };
  return axios(config).then(response => response.data)
}

export async function apiRest_removeHistory(token_id, user_id, server_addr) {  // DEL
  const config_key = 'apiRest_removeHistory'

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    }
  };
  return axios(config).then(response => response.data)
}




export async function apiRest_getRecords(token_id, user_id, type, split_id, target_team_id, target_user_id, server_addr) {  // GET

  const config_key = 'apiRest_getRecords'

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    params: {
      'split_id': split_id,
      'team_id': target_team_id,
      'user_id': target_user_id,
      'type': type
    }
  };
  return axios(config).then(response => response.data)

}

export async function apiRest_addRecord(token_id, user_id, server_addr) {  // POST
  throw new Error('[apiRest_addRecord] Not implemented')
}

export async function apiRest_updateRecord(token_id, user_id, record_id, data_in, server_addr) {  // PUT
  const config_key = 'apiRest_updateRecord'
  data_in[pServer.form_record_id] = record_id
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data : data_in
  };
  return axios(config).then(response => response.data)
}

export async function apiRest_removeRecord(token_id, user_id, type, record_id, server_addr) {  // DEL

  const config_key = 'apiRest_removeRecord'

  var formData = new FormData();
  formData.append(pServer.form_type, type);
  formData.append(pServer.form_record_id, record_id);

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: formData
  };
  return axios(config).then(response => response.data)
}


export async function apiRest_revertRemoveRecord(token_id, user_id, type, record_id, server_addr) {  // POST

  const config_key = 'apiRest_revertRemoveRecord'

  var formData = new FormData();
  formData.append(pServer.form_type, type);
  formData.append('record_id', record_id);

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: formData
  };
  return axios(config).then(response => response.data)
}

export async function apiRest_updateDefaultPermission(token_id, user_id, default_permission, server_addr) {  // PUT
  const config_key = 'apiRest_updateDefaultPermission'
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data : {'default_permission': default_permission}
  };
  return axios(config).then(response => response.data)
}

export async function apiRest_updateEmailPermission(token_id, user_id, email_permission, server_addr) {  // PUT
  const config_key = 'apiRest_updateEmailPermission'
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data : {'email_permission': email_permission}
  };
  return axios(config).then(response => response.data)
}

export async function apiRest_updateDefaultCamera(token_id, user_id, default_camera, server_addr) {  // PUT
  const config_key = 'apiRest_updateDefaultCamera'
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data : {'default_camera': default_camera}
  };
  return axios(config).then(response => response.data)
}

export async function apiRest_getMessage(token_id, user_id, server_addr) {   // GET
  // const config_key = 'sendPing'
  // const config = {
  //   method: apiRest_basic_config[config_key]['method'],
  //   url: server_addr + apiRest_basic_config[config_key]['endpoint'],
  //   timeout: apiRest_basic_config[config_key]['timeout'],
  //   auth: {
  //     username: user_id,
  //     password: token_id
  //   },
  // };

  // return axios(config).then(response => response.data)
  throw new Error('[apiRest_getMessage] Not implemented')
}

export async function apiRest_createMessage(token_id, user_id, server_addr) {  // POST
  // const config_key = 'sendPing'
  // const config = {
  //   method: apiRest_basic_config[config_key]['method'],
  //   url: server_addr + apiRest_basic_config[config_key]['endpoint'],
  //   timeout: apiRest_basic_config[config_key]['timeout'],
  //   auth: {
  //     username: user_id,
  //     password: token_id
  //   },
  // };

  // return axios(config).then(response => response.data)
  throw new Error('[apiRest_createMessage] Not implemented')
}

export async function apiRest_removeMessage(token_id, user_id, server_addr) {  // DEL
  // const config_key = 'sendPing'
  // const config = {
  //   method: apiRest_basic_config[config_key]['method'],
  //   url: server_addr + apiRest_basic_config[config_key]['endpoint'],
  //   timeout: apiRest_basic_config[config_key]['timeout'],
  //   auth: {
  //     username: user_id,
  //     password: token_id
  //   },
  // };

  // return axios(config).then(response => response.data)
  throw new Error('[apiRest_removeMessage] Not implemented')
}



export async function apiRest_getReportActivity(token_id, user_id, type, target, server_addr) {  // GET

  const config_key = 'apiRest_getReportActivity'

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    params: {
      'type': type,
      'target': target,
    }
  };
  return axios(config).then(response => response.data)

}



export async function apiRest_getReportUserActivity(token_id, user_id, server_addr) {  // GET

  const config_key = 'apiRest_getReportUserActivity'

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    }
  };
  return axios(config).then(response => response.data)

}


export async function apiRest_getReportTeamActivity(token_id, team_id, server_addr) {  // GET

  const config_key = 'apiRest_getReportUserActivity'

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    params: {
      'team_id': team_id,
    }
  };
  return axios(config).then(response => response.data)

}


export async function apiRest_createTeam(token_id, user_id, data, server_addr) {  // POST
  const config_key = 'apiRest_createTeam'

  var formData = new FormData();
  formData.append(pServer.form_team_id, data['name']);
  formData.append(pServer.form_team_label, data['label']);
  formData.append(pServer.form_team_imgBase64, data['imgBase64']);
  formData.append(pServer.form_team_email, data['email']);
  formData.append(pServer.form_team_school, data['school']);
  formData.append(pServer.form_team_zip_code, data['zip_code']);
  formData.append(pServer.form_team_information, data['information']);

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: formData
  };
  // console.log('FORMDATA')
  // console.log(formData)
  // console.log('DATA')
  // console.log(data)
  return axios(config).then(response => response.data)
}

export async function apiRest_getInfoTeam(token_id, user_id, team_id, server_addr) {    // GET
  const config_key = 'apiRest_getInfoTeam'
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    params: {
      'team_id' : team_id
    }
  };
  return axios(config).then(response => response.data)
}


export async function apiRest_removeTeam(token_id, user_id, team_id, server_addr) {  // DEL

  const config_key = 'apiRest_removeTeam'

  var formData = new FormData();
  formData.append(pServer.form_team_id, team_id);

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: formData
  };
  return axios(config).then(response => response.data)
}

export async function apiRest_updateTeam(token_id, user_id, team_id, data_in, server_addr) {  // PUT
  const config_key = 'apiRest_updateTeam'

  data_in[pServer.form_team_id] = team_id

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data : data_in
  };
  return axios(config).then(response => response.data)
}



export async function apiRest_requestInvitationMemberTeam(token_id, user_id, team_id, target_user_id, server_addr) {  // POST
  // console.log("🚀 ~ file: RESTful.js:965 ~ apiRest_requestInvitationMemberTeam ~ apiRest_requestInvitationMemberTeam:", apiRest_requestInvitationMemberTeam)
  const config_key = 'apiRest_requestInvitationMemberTeam'

  var formData = new FormData();
  formData.append(pServer.form_team_id, team_id);
  if (target_user_id!== null){
    formData.append(pServer.form_team_user_id, target_user_id);
  }

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: formData
  };
  return axios(config).then(response => response.data)
}



export async function apiRest_acceptInvitationMemberTeam(token_id, user_id, team_id, target_user_id, server_addr) {  // POST
  const config_key = 'apiRest_acceptInvitationMemberTeam'

  let data_send = {}
  data_send['team_id'] = team_id
  if (target_user_id!== null){
    data_send['user_id'] = target_user_id
  }

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: data_send
  };
  return axios(config).then(response => response.data)
}

export async function apiRest_getInfoMemberTeam(token_id, user_id, server_addr) {    // GET
  const config_key = 'apiRest_getInfoMemberTeam'
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    }
  };
  return axios(config).then(response => response.data)
}



export async function apiRest_cancelInvitationMemberTeam(token_id, user_id, target_team_id, target_user_id, server_addr) {  // DEL

  const config_key = 'apiRest_cancelInvitationMemberTeam'
  var formData = new FormData();
  formData.append(pServer.form_team_id, target_team_id);
  if (target_user_id!== null){
    formData.append(pServer.form_team_user_id, target_user_id);
  }

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: formData
  };
  return axios(config).then(response => response.data)
}






export async function apiRest_getRankDataTeam(token_id, user_id, server_addr) {    // GET
  const config_key = 'apiRest_getRankDataTeam'
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    }
  };
  return axios(config).then(response => response.data)
}



export async function apiRest_createTaskTeam(token_id, user_id, data, server_addr) {  // POST
  const config_key = 'apiRest_createTaskTeam'

  var formData = new FormData();
  formData.append(pServer.form_team_id, data['team_id']);
  formData.append(pServer.form_task_id, data['task_id']);
  formData.append(pServer.form_team_information, data['information']);
  formData.append(pServer.form_task_arr_elements, data['arr_elements']);
  formData.append(pServer.form_deadlineTimestamp, data['deadline_timestamp']);

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: formData
  };
  return axios(config).then(response => response.data)
}

export async function apiRest_getTaskTeam(token_id, user_id, target_team_id, target_task_id, target_user_id, server_addr) {    // GET
  const config_key = 'apiRest_getTaskTeam'
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    params: {
      'team_id' : target_team_id,
      'user_id' : target_user_id,
      'task_id' : target_task_id
    }
  };
  return axios(config).then(response => response.data)
}


export async function apiRest_removeTaskTeam(token_id, user_id, target_team_id, target_task_id, server_addr) {  // DEL

  const config_key = 'apiRest_removeTaskTeam'

  var formData = new FormData();
  formData.append(pServer.form_team_id, target_team_id);
  formData.append(pServer.form_task_id, target_task_id);

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: formData
  };
  return axios(config).then(response => response.data)
}

export async function apiRest_updateTaskTeam(token_id, user_id, target_task_id, data_in, server_addr) {  // PUT
  const config_key = 'apiRest_updateTaskTeam'

  data_in[pServer.form_task_id] = target_task_id

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data : data_in
  };
  return axios(config).then(response => response.data)
}



export async function apiRest_sendSubmission(token_id, user_id, type, submission_reference, submission_data, f, server_addr) {  // POST
  const config_key = 'apiRest_sendSubmission'

  var formData = new FormData();
  formData.append(pServer.form_type, type);
  formData.append(pServer.form_video, f);
  formData.append(pServer.form_submission_reference, submission_reference);
  formData.append(pServer.form_submission_data, submission_data);

  // console.log(config_key)
  // console.log(formData)

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data: formData
  };
  return axios(config).then(response => response.data)
}


export async function apiRest_getLeaderboard(token_id, user_id, type, scope, server_addr) {    // GET
  const config_key = 'apiRest_getLeaderboard'
  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    params: {
      'type' : type,
      'scope' : scope
    }
  };
  return axios(config).then(response => response.data)
}



export async function apiRest_sendResponseSurvey(token_id, user_id, data_response, server_addr) {  // PUT
  const config_key = 'apiRest_sendResponseSurvey'

  const config = {
    method: apiRest_basic_config[config_key]['method'],
    url: server_addr + apiRest_basic_config[config_key]['endpoint'],
    timeout: apiRest_basic_config[config_key]['timeout'],
    auth: {
      username: user_id,
      password: token_id
    },
    data : data_response
  };
  return axios(config).then(response => response.data)
}